import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'parseJson',
  standalone: true
})
export class ParseJsonPipe implements PipeTransform {

  constructor() { }

  transform(value: any, args?: any): string {
    let obj = JSON.parse(value);
    let array = Object.entries(obj);
    let output = array.join('\n').replace(/,/g, " = ");
    return output;

  }
}
